<template>
    <div>
        <a v-if="!isFullscreen" class="screenfull-svg" @click="click"><svg-icon icon-class="quanping"/></a>
        <a v-else class="screenfull-svg" @click="click"><svg-icon icon-class="tuichuquanping"/></a>
    </div>
</template>

<script>
    import screenfull from 'screenfull'

    export default {
        name: 'Screenfull',
        data() {
            return {
                // 是否是全屏
                isFullscreen: false
            }
        },
        methods: {
            click() {
                if (!screenfull.enabled) {
                    this.$message({
                        message: 'you browser can not work',
                        type: 'warning'
                    })
                    return false
                }
                screenfull.onchange(() => {
                    this.isFullscreen = screenfull.isFullscreen;
                })
                // 监听全屏切换事件
                screenfull.toggle();
            }
        }
    }
</script>

<style scoped>

    .screenfull-svg >>> svg {
        width: 22px;
        height: 22px;
        cursor: pointer;
        fill: #48576a;
        vertical-align: top;
    }
</style>
